import { render, staticRenderFns } from "./Font.vue?vue&type=template&id=38cf3c15&scoped=true"
import script from "./Font.vue?vue&type=script&lang=js"
export * from "./Font.vue?vue&type=script&lang=js"
import style0 from "./Font.vue?vue&type=style&index=0&id=38cf3c15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cf3c15",
  null
  
)

export default component.exports